import { Component, inject, OnInit } from '@angular/core';
import { NgbCarousel, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { BannerDto } from '../../../../core/data/dtos/banner.dto';
import { BannersService } from '../../services/banners.service';

@Component({
    selector: 'app-dashboard',
    imports: [NgbCarouselModule],
    providers: [BannersService],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  banners: BannerDto[] = [];
  private readonly bannersService = inject(BannersService);

  ngOnInit() {
    this.getBanners();
  }

  async getBanners() {
    const response = await this.bannersService.getBanners();

    this.banners = response;
  }

  goToLink(enlace_del_banner_portada_oficina_virtual: string | null) {
    if (!enlace_del_banner_portada_oficina_virtual) return;

    window.open(enlace_del_banner_portada_oficina_virtual, '_blank');
  }
}
